// Otaku Paradise Theme JS

document.addEventListener('DOMContentLoaded', function () {

  // Mobile nav toggle
  const navToggle = document.querySelector('.nav-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', function () {
      mobileNav.classList.toggle('open');
    });
  }

  // Add to cart AJAX
  const addToCartForms = document.querySelectorAll('.add-to-cart-form');
  addToCartForms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(res => res.json())
      .then(data => {
        updateCartCount();
        showAddedMessage();
        autoCloseCartDropdown();
      })
      .catch(err => console.error(err));
    });
  });

  // Update cart count in header
  function updateCartCount() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const countEl = document.querySelector('.cart-count');
        if (countEl) countEl.textContent = cart.item_count;
      });
  }

  // Show added to cart notification — auto-closes after 3.5 seconds
  function showAddedMessage() {
    // Remove any existing notification first
    const existing = document.querySelector('.cart-notification-toast');
    if (existing) existing.remove();

    const msg = document.createElement('div');
    msg.className = 'cart-notification-toast';
    msg.innerHTML = '<span style="font-size:16px;margin-right:8px;">✓</span> Added to cart!';
    msg.style.cssText = [
      'position:fixed',
      'top:80px',
      'right:20px',
      'background:#c8a84b',
      'color:#111',
      'font-family:Oswald,sans-serif',
      'font-weight:700',
      'font-size:13px',
      'letter-spacing:.08em',
      'padding:14px 22px',
      'z-index:9999',
      'box-shadow:0 4px 20px rgba(0,0,0,.35)',
      'border-radius:4px',
      'display:flex',
      'align-items:center',
      'transition:opacity .4s ease'
    ].join(';');
    document.body.appendChild(msg);

    // Fade out then remove
    setTimeout(function() {
      msg.style.opacity = '0';
      setTimeout(function() { msg.remove(); }, 400);
    }, 3100);
  }

  // Auto-close any cart dropdown/drawer that Shopify or the theme renders
  function autoCloseCartDropdown() {
    // Works for common class names used by Shopify themes for cart drawers/dropdowns
    var selectors = [
      '.cart-notification',
      '.cart-drawer',
      '.cart-popup',
      '[data-cart-notification]',
      '[data-cart-drawer]',
      '.js-cart-notification'
    ];
    selectors.forEach(function(sel) {
      var el = document.querySelector(sel);
      if (el && (el.classList.contains('open') || el.classList.contains('is-open') || el.style.display !== 'none')) {
        setTimeout(function() {
          el.classList.remove('open', 'is-open', 'active');
          el.style.display = 'none';
        }, 3500);
      }
    });
  }

  // Initialize cart count on load
  updateCartCount();

});


// Close nav dropdown when clicking outside
document.addEventListener('click', function(e) {
  var wrap = document.querySelector('.nav-dropdown-wrap');
  if (wrap && !wrap.contains(e.target)) {
    wrap.classList.remove('open');
  }
});

// Auto-close cart notification dropdowns that appear dynamically
(function() {
  var cartDropdownSelectors = [
    '.cart-notification',
    '.cart-drawer',
    '.cart-popup',
    '[data-cart-notification]',
    '.js-cart-notification'
  ];
  var AUTO_CLOSE_DELAY = 3500; // ms

  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) return;
        cartDropdownSelectors.forEach(function(sel) {
          if (node.matches && node.matches(sel)) {
            setTimeout(function() {
              node.classList.remove('open', 'is-open', 'active', 'visible');
              node.style.display = 'none';
            }, AUTO_CLOSE_DELAY);
          }
        });
      });
      // Also watch class changes (e.g. theme adds 'open' class)
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        var el = mutation.target;
        cartDropdownSelectors.forEach(function(sel) {
          if (el.matches && el.matches(sel)) {
            if (el.classList.contains('open') || el.classList.contains('is-open') || el.classList.contains('active')) {
              setTimeout(function() {
                el.classList.remove('open', 'is-open', 'active', 'visible');
              }, AUTO_CLOSE_DELAY);
            }
          }
        });
      }
    });
  });

  document.addEventListener('DOMContentLoaded', function() {
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  });
})();


// ── SMOOTH NATURAL SCROLL (subtle parallax-style) ─────────────────────────
(function() {
  // Only run on devices that can handle it and don't prefer reduced motion
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.requestAnimationFrame) return;

  var current   = window.scrollY || 0;
  var target    = current;
  var ease      = 0.085; // lower = smoother/slower, higher = snappier (0.06–0.12 sweet spot)
  var running   = false;
  var lastY     = current;

  // We intercept the scroll position with a lerp on the transform of a wrapper
  // rather than fighting native scroll (which breaks accessibility & Shopify sections).
  // Instead we add subtle parallax depth to specific non-critical elements.

  function getParallaxEls() {
    return [
      { el: document.querySelector('.hero-right'),          rate: 0.12 },
      { el: document.querySelector('.halloween-banner'),    rate: 0.07 },
      { el: document.querySelector('.hero-section'),        rate: 0.05 },
    ].filter(function(item) { return item.el !== null; });
  }

  var parallaxEls = [];

  function initParallax() {
    parallaxEls = getParallaxEls();
    parallaxEls.forEach(function(item) {
      item.el.style.willChange = 'transform';
    });
  }

  function applyParallax() {
    var scrolled = window.scrollY || 0;
    parallaxEls.forEach(function(item) {
      var rect  = item.el.getBoundingClientRect();
      var inView = rect.bottom > 0 && rect.top < window.innerHeight;
      if (!inView) return;
      // Offset relative to how far element has scrolled into view
      var offset = (scrolled - (item.el.offsetTop - window.innerHeight * 0.5)) * item.rate;
      item.el.style.transform = 'translateY(' + offset.toFixed(2) + 'px)';
    });
  }

  // Smooth section reveal — elements fade+slide up as they enter viewport
  function initReveal() {
    var candidates = document.querySelectorAll(
      '.fandom-section, .products-section, .why-section, .photos-section, .reviews-section, .trust-bar, .halloween-banner'
    );
    candidates.forEach(function(el) {
      // Only animate if not already visible on load
      var rect = el.getBoundingClientRect();
      if (rect.top > window.innerHeight * 0.1) {
        el.style.opacity = '0';
        el.style.transform = 'translateY(18px)';
        el.style.transition = 'opacity 0.55s cubic-bezier(0.22,1,0.36,1), transform 0.55s cubic-bezier(0.22,1,0.36,1)';
        el.dataset.reveal = 'pending';
      }
    });
  }

  function checkReveal() {
    var els = document.querySelectorAll('[data-reveal="pending"]');
    els.forEach(function(el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.88) {
        el.style.opacity = '1';
        el.style.transform = 'translateY(0)';
        el.dataset.reveal = 'done';
      }
    });
  }

  // Scroll-linked momentum feel via momentum-eased scroll tracking on cards
  function initCardHoverDepth() {
    var cards = document.querySelectorAll('.product-card, .fandom-card');
    cards.forEach(function(card) {
      card.addEventListener('mousemove', function(e) {
        var rect = card.getBoundingClientRect();
        var cx   = (e.clientX - rect.left) / rect.width  - 0.5;
        var cy   = (e.clientY - rect.top)  / rect.height - 0.5;
        card.style.transform = 'translateY(-4px) rotateX(' + (-cy * 5).toFixed(1) + 'deg) rotateY(' + (cx * 5).toFixed(1) + 'deg)';
        card.style.transition = 'transform 0.12s ease, box-shadow 0.22s';
      });
      card.addEventListener('mouseleave', function() {
        card.style.transform = '';
        card.style.transition = 'transform 0.35s cubic-bezier(0.22,1,0.36,1), box-shadow 0.22s';
      });
    });
  }

  var ticking = false;
  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(function() {
        applyParallax();
        checkReveal();
        ticking = false;
      });
      ticking = true;
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    initParallax();
    initReveal();
    initCardHoverDepth();
    applyParallax();
    checkReveal();
    window.addEventListener('scroll', onScroll, { passive: true });
  });

})();


// ── ENHANCED ANIMATIONS v2: STAGGER REVEAL + PARALLAX + CART BUMP ──────────
(function() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // ── STAGGERED CHILD REVEAL ──────────────────────────────────────────────
  function initStaggerReveal() {
    var groups = [
      { selector: '.fandom-grid .fandom-card',   attr: 'data-stagger-reveal' },
      { selector: '.products-grid .product-card', attr: 'data-stagger-reveal' },
      { selector: '.trust-bar .trust-item',       attr: 'data-stagger-reveal' },
      { selector: '.why-grid .why-item',          attr: 'data-stagger-reveal' },
    ];

    groups.forEach(function(group) {
      var els = document.querySelectorAll(group.selector);
      els.forEach(function(el) {
        var rect = el.getBoundingClientRect();
        if (rect.top > window.innerHeight * 0.15) {
          el.setAttribute(group.attr, 'pending');
        }
      });
    });
  }

  function checkStaggerReveal() {
    var pending = document.querySelectorAll('[data-stagger-reveal="pending"]');
    // Group siblings so they stagger from the same parent
    var parents = new Map();
    pending.forEach(function(el) {
      var p = el.parentElement;
      if (!parents.has(p)) parents.set(p, []);
      parents.get(p).push(el);
    });

    parents.forEach(function(children) {
      var firstRect = children[0].getBoundingClientRect();
      if (firstRect.top < window.innerHeight * 0.9) {
        children.forEach(function(child, i) {
          setTimeout(function() {
            child.setAttribute('data-stagger-reveal', 'done');
          }, i * 75); // 75ms stagger between each card
        });
      }
    });
  }

  // ── ENHANCED PARALLAX ──────────────────────────────────────────────────
  var parallaxItems = [];

  function initParallax() {
    var defs = [
      { sel: '.hero-right',        rate: 0.10 },
      { sel: '.halloween-banner',  rate: 0.06 },
      { sel: '.hero-section .hero-left', rate: 0.03 },
    ];
    parallaxItems = defs
      .map(function(d) { return { el: document.querySelector(d.sel), rate: d.rate }; })
      .filter(function(d) { return d.el; });

    parallaxItems.forEach(function(d) {
      d.el.style.willChange = 'transform';
      d.baseTop = d.el.getBoundingClientRect().top + (window.scrollY || 0);
    });
  }

  function applyParallax() {
    var sy = window.scrollY || 0;
    parallaxItems.forEach(function(d) {
      var rect = d.el.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;
      var offset = (sy - (d.baseTop - window.innerHeight * 0.5)) * d.rate;
      d.el.style.transform = 'translateY(' + offset.toFixed(2) + 'px)';
    });
  }

  // ── CART COUNT BOUNCE ──────────────────────────────────────────────────
  function watchCartBump() {
    var countEl = document.querySelector('.cart-count');
    if (!countEl) return;
    var prev = countEl.textContent;
    // Re-use MutationObserver from main JS if already attached — just add class
    var obs = new MutationObserver(function() {
      var curr = countEl.textContent;
      if (curr !== prev) {
        countEl.classList.remove('bump');
        void countEl.offsetWidth; // reflow
        countEl.classList.add('bump');
        prev = curr;
      }
    });
    obs.observe(countEl, { childList: true, characterData: true, subtree: true });
  }

  // ── MOBILE LOGO + MENU LINK AUDIT ─────────────────────────────────────
  // Ensure logo links in header and footer both go to "/" with correct attrs
  function auditLinks() {
    // Logo links
    document.querySelectorAll('.logo-wrap').forEach(function(el) {
      if (el.tagName === 'A') {
        if (!el.getAttribute('href') || el.getAttribute('href') === '') {
          el.setAttribute('href', '/');
        }
      }
    });

    // Nav dropdown category links — ensure they work on mobile (touch)
    document.querySelectorAll('.nav-categories-sub li a').forEach(function(a) {
      // Remove any accidental preventDefault that would block navigation
      a.addEventListener('click', function(e) {
        // Let the link navigate normally; only close the menu
        var dropWrap = document.getElementById('navDropdownWrap');
        if (dropWrap) dropWrap.classList.remove('open');
      });
    });
  }

  // ── SMOOTH HOVER UNDERLINE RESET (mobile-safe) ────────────────────────
  function mobileNavSafe() {
    // On touch devices, :hover pseudo-states stick; reset on touchend elsewhere
    if (!('ontouchstart' in window)) return;
    document.addEventListener('touchstart', function(e) {
      // no-op; just ensures touch events don't get swallowed
    }, { passive: true });
  }

  // ── SCROLL HANDLER ────────────────────────────────────────────────────
  var rafPending = false;
  function onScroll() {
    if (!rafPending) {
      rafPending = true;
      requestAnimationFrame(function() {
        applyParallax();
        checkStaggerReveal();
        rafPending = false;
      });
    }
  }

  // ── INIT ──────────────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function() {
    initParallax();
    initStaggerReveal();
    watchCartBump();
    auditLinks();
    mobileNavSafe();

    applyParallax();
    checkStaggerReveal();

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function() {
      // Re-init parallax base positions on resize
      initParallax();
    }, { passive: true });
  });

})();

// ── CATEGORY PAGE: SCROLL STAGGER REVEAL ──────────────────────────────────
(function() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function initCatReveal() {
    // Mark all pending product cards on category pages
    var cards = document.querySelectorAll('.cat-product-card');
    cards.forEach(function(card) {
      var rect = card.getBoundingClientRect();
      if (rect.top > window.innerHeight * 0.2) {
        card.setAttribute('data-stagger-reveal', 'pending');
      } else {
        // Already in view — animate in immediately
        card.setAttribute('data-stagger-reveal', 'done');
      }
    });
  }

  function checkCatReveal() {
    // Group pending cards by their parent row so stagger is per-row
    var pending = document.querySelectorAll('.cat-product-card[data-stagger-reveal="pending"]');
    if (!pending.length) return;

    var parents = new Map();
    pending.forEach(function(card) {
      var p = card.parentElement;
      if (!parents.has(p)) parents.set(p, []);
      parents.get(p).push(card);
    });

    parents.forEach(function(cards) {
      // Check if the first card in this group is near the viewport
      var first = cards[0];
      if (!first) return;
      var rect = first.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.92) {
        cards.forEach(function(card, i) {
          setTimeout(function() {
            card.setAttribute('data-stagger-reveal', 'done');
          }, i * 65);
        });
      }
    });
  }

  // Section-level reveal (homepage sections)
  function initSectionReveal() {
    var sections = document.querySelectorAll(
      '.products-section, .fandom-section, .halloween-banner, .why-section, .photos-section'
    );
    sections.forEach(function(sec) {
      var rect = sec.getBoundingClientRect();
      if (rect.top > window.innerHeight * 0.1) {
        sec.setAttribute('data-reveal', 'pending');
      }
    });
  }

  function checkSectionReveal() {
    var pending = document.querySelectorAll('[data-reveal="pending"]');
    pending.forEach(function(el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.9) {
        el.setAttribute('data-reveal', 'done');
      }
    });
  }

  var raf = false;
  function onScroll() {
    if (!raf) {
      raf = true;
      requestAnimationFrame(function() {
        checkCatReveal();
        checkSectionReveal();
        raf = false;
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    initCatReveal();
    initSectionReveal();
    checkCatReveal();
    checkSectionReveal();
    window.addEventListener('scroll', onScroll, { passive: true });
  });

})();
